import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { theme } from './shared/css/theme';
import { Routes } from './routes';
import { CssBaseline } from '@mui/material';
import './App.css';
import { Snackbar } from './shared/components/snackbar/Snackbar';
import { ApolloProvider } from './modules/apollo/Provider';
import { Auth0ProviderWithHistory } from './modules/auth/Auth0ProviderWithHistory';

export const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Auth0ProviderWithHistory>
          <ApolloProvider>
            <Snackbar />
            <Routes />
          </ApolloProvider>
        </Auth0ProviderWithHistory>
      </ThemeProvider>
    </BrowserRouter>
  );
};
